import { useEffect } from 'react';

interface PageMetaProps {
  title: string;
  description?: string;
  jsonLd?: Record<string, unknown>;
}

export default function PageMeta({ title, description, jsonLd }: PageMetaProps) {
  useEffect(() => {
    document.title = title;

    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.setAttribute('name', 'description');
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', description);
    }

    if (jsonLd) {
      const scriptId = 'page-jsonld';
      let script = document.getElementById(scriptId);
      if (script) script.remove();
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);

      return () => {
        const el = document.getElementById(scriptId);
        if (el) el.remove();
      };
    }
  }, [title, description, jsonLd]);

  return null;
}